module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize3-b8cc0e45a47ff0381b63d47506910c4f.jpg";